import {Section} from "./grouping/Section";
import {Button, Col, Row} from "react-bootstrap";
import {useArticles} from "../api/articleapi";


export function SelectionList(props) {
    const {title, children} = props

    return <Section>
        {title && <Col xs={12}>
            <h4>{title}</h4>
        </Col>}
        {children}
    </Section>
}

